import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isInitializing: false,
  isLoading: false,
  error: null,
  disbursementOfficers: [],
};

const slice = createSlice({
  name: 'internal-user-disbursement-officers',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      if (!state.disbursementOfficers || state.disbursementOfficers.length === 0) {
        state.isInitializing = true;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitializing = false;
    },

    getDisbursementOfficersSuccess(state, action) {
      state.isLoading = false;
      state.disbursementOfficers = action.payload;
      state.isInitializing = false;
    },
  },
});

export function getDisbursementOfficers() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/internal/accounts/disbursement-officers');
      dispatch(slice.actions.getDisbursementOfficersSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export default slice.reducer;
